<p-accordionTab #finalUsersProfile>
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full -mb-3">
			<div [class]="!onExtendedMobile() ? 'col-10' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{ 'ENABLED_USERS' | translate }}</span>
			</div>
			<div [class]="!onExtendedMobile() ? 'col-2 flex justify-content-end' : 'col-12 flex justify-content-center'"
				class="py-0 pr-0">
				<p-button *ngIf="hasImportFinalUsers()" pTooltip="{{ 'EXPORT_LIST_FINAL_USERS' | translate }}" class=""
					[disabled]="exporting || deleting" tooltipPosition="bottom" icon="pi cm-cloud-arrow-up" size="large"
					(click)="$event.stopPropagation(); exportListFinalUser()" [rounded]="false" [text]="true"
					severity="secondary">
				</p-button>
				<p-button pTooltip="{{ 'DELETE_ALL' | translate }}" class="" [disabled]="exporting || deleting"
					tooltipPosition="bottom" icon="pi cm-trash" size="large"
					(click)="$event.stopPropagation(); deleteFinalUsers()" [rounded]="false" [text]="true" severity="danger">
				</p-button>
			</div>
		</div>
	</ng-template>
	<div class="grid">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl"
			*ngIf="deviceFinalUsers.length <= 0">
			<p-tag icon="pi cm-alert" [value]="('NO_FINAL_USERS' | translate)" severity="warning"
				styleClass="text-lg"></p-tag>
		</div>
		<div class="col-12" *ngIf="deviceFinalUsers.length > 0">
			<p-table #tableClaimedSlots dataKey="Email" [value]="deviceFinalUsers" [paginator]="true" [rows]="pageSize"
				[totalRecords]="totalRecords" [showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th style="width: 5rem"></th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'FIRST_NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'LAST_NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'EMAIL' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'INVITATION' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-user let-expanded="expanded">
					<tr>
						<td>
							<button type="button" pButton pRipple [pRowToggler]="user" class="p-button-rounded p-button-plain"
								[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'"
								(click)="onUserClicked(!expanded,user)"></button>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'FIRST_NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ user.FirstName }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'LAST_NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ user.LastName }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'EMAIL' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ user.Email }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'INVITATION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">
								<p-tag
									[value]="!user.Id? ('INVITATION_PENDING_NEW' | translate) : ('INVITATION_ACCEPTED_NEW' | translate)"
									[severity]="!user.Id? 'warning' : 'success'">
								</p-tag>
							</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'DELETE_USER' | translate}}" tooltipPosition="bottom" icon="pi cm-trash"
									size="large" (click)="deleteUser(user)" [rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="rowexpansion" let-user>
					<tr>
						<td colspan="12" class="p-0 px-3">
							<div *ngIf="!checkUserId(user.Id)"
								class="flex flex-row w-full align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
								<p-tag icon="pi cm-alert"
									[value]="('INVITATION' | translate) + ': ' + ('INVITATION_PENDING_NEW' | translate)"
									severity="warning" styleClass="text-lg"></p-tag>
							</div>
							<div *ngIf="checkUserId(user.Id)"
								class="flex flex-row w-full align-items-center justify-content-center bg-blue-200 p-1 border-round-xl py-3">
								<p-checkbox *ngFor="let profile of finalUserProfiles.get(user.Id)" [(ngModel)]="profile.Checked"
									(onChange)="onUserProfileChanged($event, user.Id, profile)" [binary]="true"
									[label]="profile.Name" class="ml-4 text-primary">
								</p-checkbox>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="col-12 flex justify-content-center">
				<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
				</button>
				<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
				</button>
			</div>
		</ng-template>
	</p-confirmDialog>
</p-accordionTab>